import ComicCard from "@/components/feature/ComicCard";
import { featuredComics } from "@/mocks/comics";

export default function FeaturedComics() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              <i className="ri-fire-line text-primary-500 mr-2"></i>热门推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-1">编辑精选 · 大家都在看</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5" data-product-shop="">
          {featuredComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              status={comic.status}
              rating={comic.rating}
              views={comic.views}
              tags={comic.tags}
              chapters={comic.chapters}
            />
          ))}
        </div>
      </div>
    </section>
  );
}